import { ENDPOINTS, SCRIPT_PROD_URL } from "./constants";
export const ABORT_ERROR = "REQUEST_ABORTED";

export const makeApiRequests = async ({ requestType, requestBody }) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  try {
    const response = await (
      await fetch(SCRIPT_PROD_URL, {
        method: "POST",
        body: JSON.stringify({
          accessToken: token,
          requestType,
          payload: requestBody,
        }),
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
      })
    ).json();

    if (response["success"]) {
      return { response };
    } else {
      return { error: response["message"] || "Oops something went wrong!" };
    }
  } catch (e) {
    return { error: "Oops something went wrong!" };
  }
};

//calculate in mb
export const sizeOf = (string) => {
  const bytes = new TextEncoder().encode(string).length;
  return bytes / (1024 * 1024);
};

// REST API Request Handler
export const makeRESTApiRequests = async ({
  endpoint,
  contentType = "application/json",
  requestBody,
  method = "POST",
  stringify = true,
  signal,
}) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const headers = {
    Authorization: token ? `Bearer ${token}` : undefined,
  };
  if (endpoint !== ENDPOINTS.FILE) {
    headers["Content-Type"] = contentType;
  }
  try {
    const response = await fetch(process.env.REACT_APP_API_URL + endpoint, {
      method: method,
      body: requestBody
        ? stringify
          ? JSON.stringify(requestBody)
          : requestBody
        : undefined,
      headers,
      signal,
    });

    const responseBody = await response.json();
    if (response.status < 200 || response.status >= 300) {
      if (response.status === 401) {
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 1500);
        return {
          error: "Your session has expired, please try logging in again!",
        };
      }
      return { error: responseBody["message"] || "Oops something went wrong!" };
    } else {
      return { response: responseBody };
    }
  } catch (e) {
    if (e.name === "AbortError") {
      return { error: ABORT_ERROR };
    }

    return { error: "Oops something went wrong!" };
  }
};
